/*
 * View for the language selector on the content page
 */

define([
  "marionette",
  "modules/contentsSplit/content/contentLanguage/template/contentLanguageTemplate.html",
], function (Marionette, ContentLanguageTemplate) {
  var ContentLanguageView = {};
  ContentLanguageView.contentLanguageView = Marionette.ItemView.extend({
    template: ContentLanguageTemplate,
    events: {
      "change #languages": function () {
        var optionSelected = this.$el.find("#languages option:selected").val();
        this.trigger("change:language", optionSelected);
      },
    },
  });

  return ContentLanguageView;
});
